export default "__VITE_ASSET__COJcP7Qd__"